import React, { FC } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { get } from 'lodash';
import { Form } from '~/components';
import WizardForm from '~/components/WizardForm';
import { Draft } from '~/types/Draft';
import InputsGroupLayout from '~/layouts/InputsGroupLayout';
import { Stage } from '~/types/Application';
import PersonReviewFormItems from '~/pages/ksa/review/managers/components/PersonReviewFormItems';
import { getIndividualsFormName } from '~/pages/ksa/application/shareholders/components/individuals/IndividualEdit';
import ReviewItem from '~/pages/ksa/review/components/ReviewItem';
import { useGetPayload } from '~/controllers/wizard';
import { KsaIndividualShareholder } from '~/types/ksa/KsaIndividualShareholder';
import StepReviewComment from '~/pages/ksa/review/components/StepReviewComment';
import buildNamePath from '~/utils/buildNamePath';
import Section from '~/layouts/Section ';
import { KsaPerson } from '~/types/ksa/KsaPerson';
import ShareholdersProofs from './ShareholdersProofs';

const ShareholdersSoleProprietor: FC = () => {
  const { t } = useTranslation('ksaApplication');
  const [form] = Form.useForm<Draft<'reviewShareholders'>>();
  const payload = useGetPayload();

  const individualShareholder: KsaIndividualShareholder | undefined = get(
    payload,
    getIndividualsFormName(0)
  );
  const individualFromProvided: KsaPerson | undefined = get(
    payload?.provided,
    getIndividualsFormName(0)
  );


  return (
    <WizardForm<Draft<'reviewShareholders'>>
      payloadKey={formName}
      form={form}
      stage={Stage.ksaReview}
    >
      <ShareholdersProofs />
      <PersonReviewFormItems
        formItemsPath={getReviewIndividualsFormName(0)}
        payloadReferencePath={getIndividualsFormName(0)}
        hasPassport={!!individualFromProvided?.passport?.documentNumber}
        hasPersonalDocument={!!individualFromProvided?.personalDocument?.idNumber}
        isSignedWithEmail={!!individualFromProvided?.personalData?.email}
        hasVerifiedPhoneNumber={
          !!individualFromProvided?.personalData?.phoneNumber ||
          !!individualShareholder?.personalData?.phoneNumber
        }
      />
      <section>
        <Typography.Title level={5}>{t('Ownership share:').toUpperCase()}</Typography.Title>
        <InputsGroupLayout>
          <ReviewItem label={t('Shares, %')}>
            {individualShareholder?.ownershipShare?.percent}
          </ReviewItem>
          <ReviewItem label={t('Shares count')}>
            {individualShareholder?.ownershipShare?.count}
          </ReviewItem>
        </InputsGroupLayout>
      </section>
      <Section>
        <StepReviewComment n={buildNamePath(formName)} />
      </Section>
    </WizardForm>
  );
};

const formName = 'reviewShareholders';
const individualsFormEntity = 'individuals';
const getReviewIndividualsFormName = (index: number) => [formName, individualsFormEntity, index];

export default ShareholdersSoleProprietor;
